module.exports = __webpack_public_path__ + "img/1605.785fbf46.png";